export const theme = {
  token: {
    colorPrimary: '#8c8c8c',
  },
}
